<div class="flex h-full flex-col overflow-hidden border-r border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900">
  <div class="border-b border-gray-200 px-4 py-3 dark:border-gray-800">
    <h3 class="text-sm font-semibold text-gray-800 dark:text-white/90">Pasos</h3>
    <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400">Arrastra o haz clic para agregar</p>
  </div>

  <!-- Buscador -->
  <div class="border-b border-gray-200 px-3 py-2 dark:border-gray-800">
    <div class="relative">
      <i class="fa-solid fa-magnifying-glass absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-gray-400"></i>
      <input
        type="text"
        [ngModel]="search()"
        (ngModelChange)="search.set($event)"
        placeholder="Buscar pasos…"
        class="w-full rounded-lg border border-gray-200 bg-white py-1.5 pl-8 pr-3 text-xs text-gray-900 focus:outline-none focus:ring-1 focus:ring-brand-500 dark:border-gray-700 dark:bg-gray-800 dark:text-white" />
    </div>
  </div>

  <div class="flex-1 overflow-y-auto px-3 py-3">
    @if (loading()) {
      <div class="flex justify-center py-8 text-gray-400">
        <i class="fa-solid fa-spinner animate-spin"></i>
      </div>
    } @else {
      @for (group of groups(); track group.label) {
        <div class="mb-4">
          <p class="mb-2 px-1 text-[11px] font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">
            {{ group.label }}
          </p>
          <div class="flex flex-col gap-1">
            @for (item of group.items; track item.nodeType + '/' + item.nodeSubtype) {
              <div
                class="flex items-center gap-2.5 rounded-lg border border-transparent px-2 py-2 transition-colors"
                [class.cursor-grab]="!isDisabled(item)"
                [class.hover:border-gray-200]="!isDisabled(item)"
                [class.hover:bg-gray-50]="!isDisabled(item)"
                [class.dark:hover:border-gray-700]="!isDisabled(item)"
                [class.dark:hover:bg-white/5]="!isDisabled(item)"
                [class.cursor-not-allowed]="isDisabled(item)"
                [class.opacity-40]="isDisabled(item)"
                [attr.draggable]="!isDisabled(item)"
                [attr.aria-disabled]="isDisabled(item)"
                [title]="tooltip(item)"
                (click)="onItemClick(item)"
                (dragstart)="onDragStart($event, toPayload(item), isDisabled(item))">
                <span class="flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-xs"
                      [class]="meta[item.nodeType].iconClass">
                  <i [class]="meta[item.nodeType].icon"></i>
                </span>
                <span class="min-w-0 flex-1">
                  <span class="block truncate text-xs font-medium text-gray-700 dark:text-gray-200">
                    {{ item.label }}
                  </span>
                </span>
                @if (isDisabled(item)) {
                  <i class="fa-solid fa-lock text-[10px] text-gray-400"></i>
                }
              </div>
            }
          </div>
        </div>
      }

      <!-- Nota visual (siempre disponible salvo modo lectura) -->
      <div class="mb-2">
        <p class="mb-2 px-1 text-[11px] font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">
          Anotaciones
        </p>
        <div
          class="flex items-center gap-2.5 rounded-lg border border-transparent px-2 py-2 transition-colors"
          [class.cursor-grab]="!readOnly()"
          [class.hover:border-gray-200]="!readOnly()"
          [class.hover:bg-gray-50]="!readOnly()"
          [class.dark:hover:border-gray-700]="!readOnly()"
          [class.dark:hover:bg-white/5]="!readOnly()"
          [class.cursor-not-allowed]="readOnly()"
          [class.opacity-40]="readOnly()"
          [attr.draggable]="!readOnly()"
          title="Agrega una nota de texto libre al lienzo"
          (click)="onAnnotationClick()"
          (dragstart)="onDragStart($event, annotationItem, readOnly())">
          <span class="flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-xs"
                [class]="meta['ANNOTATION'].iconClass">
            <i [class]="meta['ANNOTATION'].icon"></i>
          </span>
          <span class="min-w-0 flex-1">
            <span class="block truncate text-xs font-medium text-gray-700 dark:text-gray-200">Nota</span>
          </span>
        </div>
      </div>

      @if (!groups().length) {
        <p class="px-1 py-6 text-center text-xs text-gray-400">No se encontraron pasos.</p>
      }
    }
  </div>
</div>
